import { render } from "./DetailProduk.vue?vue&type=template&id=e85b2438"
import script from "./DetailProduk.vue?vue&type=script&lang=js"
export * from "./DetailProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__